import PasswordChangeForm from './PasswordChangeForm';

export default PasswordChangeForm;
